import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useI18n } from '@/contexts/I18nContext';

type SocialFields = {
  instagram: string;
  x: string;
  facebook: string;
  youtube: string;
  website: string;
};

type SocialStepProps = {
  selected: {
    instagram: string;
    x: string;
    facebook: string;
    youtube: string;
    website: string;
  };
  setSelected: React.Dispatch<React.SetStateAction<{
    instagram: string;
    x: string;
    facebook: string;
    youtube: string;
    website: string;
  }>>;
};

export function SocialStep({ selected, setSelected }: SocialStepProps) {
  const { t } = useI18n();
  return (
    <div>
      <h2 className="text-lg font-semibold mb-2 font-sans">{t('onboarding.social.title')}</h2>
      <p className="mb-4 text-black font-sans">{t('onboarding.social.subtitle')}</p>
      <div className="space-y-3">
        <Input
          type="text"
          placeholder={`${t('onboarding.social.instagram')} (e.g. @username)`}
          value={selected.instagram}
          onChange={e => setSelected(s => ({ ...s, instagram: e.target.value }))}
          className="bg-white text-black placeholder:text-[#b0b0b0] border-black font-sans"
          labelColor="#b0b0b0"
        />
        <Input
          type="text"
          placeholder={`${t('onboarding.social.x_twitter')} (e.g. @username)`}
          value={selected.x}
          onChange={e => setSelected(s => ({ ...s, x: e.target.value }))}
          className="bg-white text-black placeholder:text-[#b0b0b0] border-black font-sans"
          labelColor="#b0b0b0"
        />
        <Input
          type="text"
          placeholder={`${t('onboarding.social.facebook')} (e.g. @username)`}
          value={selected.facebook}
          onChange={e => setSelected(s => ({ ...s, facebook: e.target.value }))}
          className="bg-white text-black placeholder:text-[#b0b0b0] border-black font-sans"
          labelColor="#b0b0b0"
        />
        <Input
          type="text"
          placeholder={`${t('onboarding.social.youtube')} (e.g. @username)`}
          value={selected.youtube}
          onChange={e => setSelected(s => ({ ...s, youtube: e.target.value }))}
          className="bg-white text-black placeholder:text-[#b0b0b0] border-black font-sans"
          labelColor="#b0b0b0"
        />
        <Input
          type="text"
          placeholder={t('onboarding.social.website')}
          value={selected.website}
          onChange={e => setSelected(s => ({ ...s, website: e.target.value }))}
          className="bg-white text-black placeholder:text-[#b0b0b0] border-black font-sans"
          labelColor="#b0b0b0"
        />
      </div>
    </div>
  );
} 